module.exports = __webpack_public_path__ + "img/planet-uranus-internal.b68195d8.svg";